import { PlayerAdStartedEvent } from "../../../ads/PlayerAdEvent.js";
import { PlayerEvent } from "../../../events/PlayerEvent.js";
import { MediaInfoRawData } from "../../../../model/MediaInfo.js";
import { ExecutionId } from "../../../player/MediaResource.js";
import { ComScoreStreamingTag, ComScoreStreamingTagFactory } from "./ComScoreStreamingTag.js";

/**
 * Tag no-op usato in caso di opt-out Audicom: l'SDK Video Comscore non è stato
 * inizializzato (o non è stato nemmeno caricato), quindi ogni evento di playback
 * è ignorato e nessun dato viene raccolto/trasmesso.
 *
 * Vive in un file separato SENZA dipendenze dal vendor Comscore, così può essere
 * usato dal factory dinamico ({@link NoOpComScoreStreamingTagFactory}) senza forzare
 * il download del chunk "ComScoreModule".
 */
export class NoOpComScoreStreamingTag implements ComScoreStreamingTag {

    constructor(
        public readonly currentMediaInfo: MediaInfoRawData<any>,
        public readonly currentExecutionId: ExecutionId
    ) { }

    play(_currentTime: number): void { }
    pause(): void { }
    bufferStart(): void { }
    bufferEnd(): void { }
    end(): void { }
    adStarted(_evt: PlayerAdStartedEvent): void { }
    adEnded(): void { }
    adPaused(): void { }
    adResumed(): void { }
}

/**
 * Factory no-op restituita in opt-out: non importa il modulo Comscore (quindi non
 * scarica il vendor JS) e produce solo tag no-op.
 */
export class NoOpComScoreStreamingTagFactory implements ComScoreStreamingTagFactory {

    getStreamingTag(mle: PlayerEvent): Promise<ComScoreStreamingTag> {
        const info = (mle as any).info as MediaInfoRawData<any>;
        return Promise.resolve(new NoOpComScoreStreamingTag(info, mle.executionId));
    }
}
